<template>
  <div class="countdown">
    <!-- 时间显示 -->
    <div class="time-display">
      <span class="time">{{ hours }}</span>
      <span class="colon">:</span>
      <span class="time">{{ minutes }}</span>
      <span class="colon">:</span>
      <span class="time">{{ seconds }}</span>
    </div>
  </div>
</template>

<script>
export default {
    props: {
        totalSeconds: {
            type: Number,
            default: 60,
        },
    },
    data() {
        return {
            remainingSeconds: 60,
            timer: null,
            isRunning: false,
            isCompleted: false,
        };
    },

    computed: {
        hours() {
            return Math.floor(this.remainingSeconds / 3600)
                .toString()
                .padStart(2, "0");
        },
        minutes() {
            return Math.floor((this.remainingSeconds % 3600) / 60)
                .toString()
                .padStart(2, "0");
        },
        seconds() {
            return (this.remainingSeconds % 60).toString().padStart(2, "0");
        },
    },
    mounted() {

    },
    methods: {
        startCountdown() {
            if (this.totalSeconds <= 0) return;

            this.remainingSeconds = this.totalSeconds;
            this.isRunning = true;
            this.isCompleted = false;

            this.timer = setInterval(() => {
                this.remainingSeconds--;
                if (this.remainingSeconds <= 0) {
                    this.completeCountdown();
                }
            }, 1000);
        },

        pauseCountdown() {
            clearInterval(this.timer);
            this.isRunning = false;
        },

        resetCountdown() {
            this.isCompleted = false;
            this.remainingSeconds = this.totalSeconds;
        },

        completeCountdown() {
            clearInterval(this.timer);
            this.isRunning = false;
            this.isCompleted = true;
            this.$emit("end");
        },
    },
    beforeUnmount() {
        clearInterval(this.timer);
    },
};
</script>

<style scoped>
.countdown {
    max-width: 300px;
    margin: 0px auto;
    color: #2196f3;
    text-align: center;
    border-radius: 4px;
}

.time-display {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
      line-height: 36px;
    margin: 15px 0 0 0;
}

.time {
    display: inline-block;
    min-width: 50px;
    padding: 5px;
    border-radius: 3px;
}

.colon {
    margin: 0 5px;
}

.controls {
    margin: 10px 0;
}

.input {
    width: 80px;
    padding: 5px;
    margin-right: 10px;
    border: 1px solid #ddd;
    border-radius: 3px;
}

.btn {
    padding: 5px 12px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 3px;
    font-size: 14px;
}

.start {
    background: #4caf50;
    color: white;
}

.pause {
    background: #ff9800;
    color: white;
}

.reset {
    background: #2196f3;
    color: white;
}

.complete {
    color: #f44336;
    font-weight: bold;
    margin: 10px 0 0;
}
</style>
